export const addClassToCarausalSectionChecker = ["19"];
export const learnMoreDisplayShouldFlex = ["48", "34"];
export const learnMoreDisplayShouldTable = [
  "81",
  "58",
  "74",
  "61",
  "69",
  "86",
  "64",
  "65",
  "46",
  "60",
  "37",
];
export const removeDropDownClass = ["12", "84", "86", "65", "87"];
export const adaTenants = [
  "84",
  "40",
  "42",
  "86",
  "65",
  "87",
  "88",
  "85",
  "89",
  "17",
];
export const noFixedHeaderForMobileAccordion = ["85", "88"];
export const menuCheckerForOnClickNotHavingLi = [87, 88, 89, 90];
export const customVisitorCheckers = ["87"];
export const notRequiredAmountConversion = [89];
export const mobileDefaultHeaderRetroactiveChange = [64, 72];
export const adaCheckerForLeftAndRightArrow = [42, 84, 85, 87];
export const adaCheckerForSlideAnnounce = [85];
